import React from 'react'
import styled from 'styled-components'

const Contact = () => {
  return (
    <Wrapper>
    
    </Wrapper>
  )
}
const Wrapper = styled.section`
 
`

export default Contact
